import { action } from "satcheljs";

import { ClearFiltersActionMessage } from "./ClearFiltersActionMessage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";

/**
 * Creates the action to clear the schedule view filters.
 */
export const clearFilters = action<ClearFiltersActionMessage, (shouldClearLabel: boolean, viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore) => ClearFiltersActionMessage>(
    "CLEAR_FILTERS",
    (shouldClearLabel: boolean, viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore) => ({ shouldClearLabel, viewState })
);
